import * as endpoints from './endpoints';

export default endpoints;